export const COLOR_BLACK = "#000"
export const COLOR_LESS_BLACK = "#15161a"
export const COLOR_WHITE = "#fff"
export const COLOR_LIGHT_GRAY = "#707070"
export const COLOR_VERY_LIGHT_GRAY = "#F0F0F0"
export const COLOR_SLIGHTLY_DARKER_WHITE = "#FDFDFD"
export const COLOR_GOLD = "#FFD700"
export const COLOR_GREEN = "#56e817"
export const COLOR_MAIN = "#001a2d"